import { GetterTree } from 'vuex'
import { RootState } from '../types'
import { DoctorState } from './types'

export const getters: GetterTree<DoctorState, RootState> = {
  getFullName(state: DoctorState): string {
    return (
      state.doctor?.name +
      ' ' +
      state.doctor?.firstSurname +
      ' ' +
      state.doctor?.secondSurname
    )
  }
}
